"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouter = require("react-router");

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class RouterLink extends _react.Component {
  render() {
    const _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          selected = _this$props.selected,
          expanded = _this$props.expanded,
          value = _this$props.value,
          disabled = _this$props.disabled,
          haspopup = _this$props.haspopup,
          target = _this$props.target,
          onClick = _this$props.onClick,
          onToggle = _this$props.onToggle,
          tabindex = _this$props.tabindex,
          controls = _this$props.controls;
    const url = this.props.to || this.props.url;
    const external = url.startsWith('//') || url.startsWith('http://') || url.startsWith('https://');

    if (!external && url && this.context && this.context.history) {
      return _react.default.createElement(_reactRouterDom.Link, {
        to: url,
        className: className,
        style: style,
        onClick: onClick,
        target: target,
        tabindex: tabindex,
        "aria-controls": controls,
        "aria-haspopup": haspopup,
        "aria-selected": selected,
        "aria-expanded": expanded
      }, this.props.children);
    }

    if (url) {
      return _react.default.createElement("a", {
        href: url,
        className: className,
        style: style,
        onClick: onClick,
        target: target,
        tabindex: tabindex,
        "aria-controls": controls,
        "aria-haspopup": haspopup,
        "aria-selected": selected,
        "aria-expanded": expanded
      }, this.props.children);
    }

    return _react.default.createElement("div", {
      className: className,
      style: style,
      onClick: onClick,
      onToggle: onToggle,
      value: value,
      disabled: disabled,
      tabindex: tabindex,
      "aria-controls": controls,
      "aria-haspopup": haspopup,
      "aria-selected": selected,
      "aria-expanded": expanded
    }, this.props.children);
  }

}

_defineProperty(RouterLink, "contextType", _reactRouter.__RouterContext);

var _default = RouterLink;
exports.default = _default;
module.exports = exports.default;